import { JSX } from 'react';
import StyledLoadingDot from '../../styles/StyledLoadingDot';
import StyledLoadingDotsContainer from '../../styles/StyledLoadingDotsContainer';
import StyledLoadingMessages from '../../styles/StyledLoadingMessages';

const LoadingMessages = (): JSX.Element => {
  return (
    <StyledLoadingMessages>
      <StyledLoadingDotsContainer>
        <StyledLoadingDot $animationDelay='0s' />
        <StyledLoadingDot $animationDelay='0.2s' />
        <StyledLoadingDot $animationDelay='0.4s' />
      </StyledLoadingDotsContainer>
    </StyledLoadingMessages>
  );
};

export default LoadingMessages;